import { render, staticRenderFns } from "./ContactEn.vue?vue&type=template&id=def072f4&scoped=true&"
import script from "./ContactEn.vue?vue&type=script&lang=js&"
export * from "./ContactEn.vue?vue&type=script&lang=js&"
import style0 from "./ContactEn.vue?vue&type=style&index=0&id=def072f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def072f4",
  null
  
)

export default component.exports